export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const MENU_COLLAPSED = "MENU_COLLAPSED";
export const SIDEBAR_TOGGLED = "SIDEBAR_TOGGLED";